import {
  reactQueryGet,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import { recommendations } from "@/react/helpers/urlHelpers/internalApi/recommendations";
import type { CommunityMember } from "@/react/types";

export interface Recommendation {
  id: number;
  target: CommunityMember;
}

export interface GetRecommendationsResponse {
  count: number;
  has_next_page: boolean;
  page: number;
  page_count: number;
  per_page: number;
  records: Recommendation[];
}

export const recommendationsApi = {
  getRecommendations: (params: { page: number; per_page: number }) =>
    reactQueryGet<GetRecommendationsResponse>(recommendations.index(params)),
  dismissRecommendation: (id: string) =>
    reactQueryPut(recommendations.dismiss(id)),
};
